export default "__VITE_ASSET__eeea270e__"